/* istanbul ignore file */
import Oauth2Authenticator from './oauth2';

export default class MicrosoftAuthenticator extends Oauth2Authenticator {}
